import * as ActionTypes from './../constants';
import { baseUrl } from './../index';
import AsyncStorage from '@react-native-community/async-storage';
import axios from 'axios';
import { getUserToken } from './../getUserToken';
 

export default function(state={}, action) {
    
    switch(action.type) {
        case(ActionTypes.REQUEST_LOGOUT):
            return {
                ...state,
                loading: true,
                error: false,
                successMsg: null,
                errInfo: null
            }
        case(ActionTypes.RECEIVED_LOGOUT):
            return {
                ...state,
                loading: false,
                successMsg: action.msg,
                error: false,
                errInfo: null
            }
        case(ActionTypes.ERROR_LOGOUT):
            return {
                ...state,
                loading: false,
                successMsg: null,
                error: true,
                errInfo: action.msg
            }
        case(ActionTypes.CLEAR_LOGOUT_ALL_DATA):
            return {}
        default: return state

    }
}

const dispatchRequestLogout = () => ({
    type: ActionTypes.REQUEST_LOGOUT
})

const dispatchReceivedLogout = msg => ({
    type: ActionTypes.RECEIVED_LOGOUT,
    msg
})

const dispatchErrorLogout = msg => ({
    type: ActionTypes.ERROR_LOGOUT,
    msg
})

export const dispatchClearLogout = () => ({
    type: ActionTypes.CLEAR_LOGOUT_ALL_DATA
})





export const logout = () => dispatch => {
    AsyncStorage.getItem('authKey', (err, res) => {
        dispatch(dispatchRequestLogout());
        AsyncStorage.clear();
        const token = res;     
      
        if(err) return dispatch(dispatchErrorLogout('something went wrong...'));
        const options = {
            method: 'post',
            url: `${baseUrl}/api/logout`,
            headers: {
                Authorization: `Bearer ${token}`
                // Authorization: `Bearer ${res}`
            }
        }
        if(res) {
            axios(options).then( ({data}) => {
                dispatch(dispatchReceivedLogout(data))
            }).catch(e => {
                dispatch(dispatchErrorLogout(e));
            })
        }else{
            dispatch(dispatchErrorLogout('something went wrong...', res, 'response error'));
        }
    })

}